/* DORYD homepage sections: hero slider, tabs, add to cart */
(function () {
  if (window.__dhHome) return;
  window.__dhHome = true;

  function initSlider(root) {
    if (root.dataset.dhInit) return;
    root.dataset.dhInit = '1';
    var track = root.querySelector('.dh-slides');
    var dots = root.querySelector('.dh-dots');
    if (!track) return;
    var today = new Date();
    [].slice.call(track.children).forEach(function (s) {
      var st = s.dataset.start, en = s.dataset.end;
      if ((st && new Date(st + 'T00:00:00') > today) || (en && new Date(en + 'T23:59:59') < today)) {
        if (!window.Shopify || !Shopify.designMode) s.remove();
      }
    });
    var slides = track.children;
    if (!slides.length) { root.hidden = true; return; }
    if (slides.length < 2 || !dots) return;
    dots.innerHTML = '';
    for (var i = 0; i < slides.length; i++) {
      (function (i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Slide ' + (i + 1));
        b.onclick = function () { go(i); stop(); };
        dots.appendChild(b);
      })(i);
    }
    function idx() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) { track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' }); }
    function upd() { var c = idx(); [].forEach.call(dots.children, function (b, j) { b.setAttribute('aria-current', j === c ? 'true' : 'false'); }); }
    track.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    upd();
    var prev = root.querySelector('[data-dh-prev]'), next = root.querySelector('[data-dh-next]');
    if (prev) prev.onclick = function () { go((idx() - 1 + slides.length) % slides.length); stop(); };
    if (next) next.onclick = function () { go((idx() + 1) % slides.length); stop(); };
    var timer = null;
    function stop() { if (timer) clearInterval(timer); timer = null; }
    var speed = parseInt(root.dataset.autoplay || '0', 10);
    if (speed > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      timer = setInterval(function () { go((idx() + 1) % slides.length); }, speed * 1000);
      track.addEventListener('pointerdown', stop, { once: true });
    }
  }

  function initAll(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-dh-slider]'), initSlider);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.dh-tab');
    if (!b) return;
    var list = b.closest('.dh-tabs');
    [].forEach.call(list.querySelectorAll('.dh-tab'), function (x) {
      var on = x === b;
      x.setAttribute('aria-selected', on ? 'true' : 'false');
      var p = document.getElementById(x.getAttribute('aria-controls'));
      if (p) p.hidden = !on;
    });
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('.dh-opt__select');
    if (!sel) return;
    var card = sel.closest('.dh-card');
    var data = card.querySelector('.dh-variants');
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (err) { return; }
    var values = [].map.call(card.querySelectorAll('.dh-opt__select'), function (s) { return s.value; });
    var match = variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === values[i]; });
    })[0];
    var btn = card.querySelector('.dh-add');
    if (!match) {
      if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; }
      return;
    }
    var input = card.querySelector('.dh-atc [name=id]');
    if (input) input.value = match.id;
    if (btn) { btn.disabled = !match.available; btn.textContent = match.available ? 'Add to cart' : 'Sold out'; }
    var price = card.querySelector('.dh-price');
    if (price) {
      price.textContent = match.price;
      if (match.compare) { var s = document.createElement('s'); s.textContent = match.compare; price.appendChild(s); }
    }
    var badge = card.querySelector('.dh-badge');
    if (badge) { badge.hidden = !match.save; if (match.save) badge.textContent = 'Save ' + match.save; }
    var img = card.querySelector('.dh-img img');
    if (img && match.image) { img.removeAttribute('srcset'); img.src = match.image; }
  });

  /* Themes with a jQuery mini cart drawer (theme.miniCart, e.g. NiceG): add, then refresh and open the drawer */
  function addMiniCart(form) {
    var btn = form.querySelector('[type=submit]');
    var label = btn.textContent;
    btn.disabled = true;
    var fd = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: +fd.get('id'), quantity: +(fd.get('quantity') || 1) }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          btn.textContent = res.j.description || res.j.message || 'Could not add';
          setTimeout(function () { btn.textContent = label; }, 2500);
          return;
        }
        theme.miniCart.updateElements();
        if (typeof theme.miniCart.generateCart === 'function') theme.miniCart.generateCart();
        var mc = document.querySelector('.js-mini-cart');
        if (mc && mc.getAttribute('data-cartmini') === 'true') mc.classList.add('active');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));
      })
      .catch(function () { form.submit(); })
      .finally(function () { btn.disabled = false; });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.dh-atc');
    if (!form || !window.fetch) return;
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!cart || typeof cart.renderContents !== 'function' || typeof cart.getSectionsToRender !== 'function') {
      if (window.theme && theme.miniCart && typeof theme.miniCart.updateElements === 'function') { e.preventDefault(); addMiniCart(form); }
      return;
    }
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    btn.disabled = true;
    var fd = new FormData(form);
    fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
    fd.append('sections_url', window.location.pathname);
    cart.setActiveElement && cart.setActiveElement(btn);
    fetch((window.routes && routes.cart_add_url) || '/cart/add', {
      method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          var old = btn.textContent;
          btn.textContent = res.description || res.message || 'Could not add';
          setTimeout(function () { btn.textContent = old; }, 2500);
          return;
        }
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(res);
        if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'dh-home', productVariantId: fd.get('id'), cartData: res });
      })
      .catch(function () { form.submit(); })
      .finally(function () { btn.disabled = false; });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
